<template>
  <div class="main_Container">
    <section class="p-4">
      <div class="container-fluid">
        <div class="card">
          <div class="card-body">
            <form>
              <div class="card-body__form">
                <div class="row">
                  <div class="col-lg-6">
                    <!-- Banner Title -->
                    <div class="form-group">
                      <label for="bannerTitle">العنوان</label>

                      <textarea
                        class="form-control"
                        placeholder="العنوان"
                        id="title"
                        cols="30"
                        :value="banner.title"
                        rows="6"
                        readonly
                        v-if="banner.title"
                      ></textarea>
                      <div class="img__container mt-2" v-else>
                        <span>لا يوجد عنوان</span>
                      </div>
                    </div>
                    <!-- Banner Image -->
                    <div class="from-group">
                      <label for="">صورة الاعلان</label>
                      <div class="img-container mt-2" v-if="banner.image_url">
                        <img
                          :src="banner.image_url"
                          class="img-fluid"
                          alt="banner image"
                        />
                      </div>
                      <div class="img__container mt-2" v-else>
                        <span>لا توجد صورة</span>
                      </div>
                    </div>
                  </div>
                  <!-- Banner Data -->
                  <div class="col-lg-6">
                    <!-- Short Description -->
                    <div class="form-group">
                      <label for="title">وصف قصير</label>
                      <textarea
                        class="form-control"
                        placeholder="وصف قصير"
                        id="title"
                        cols="30"
                        :value="banner.description"
                        rows="6"
                        readonly
                        v-if="banner.description"
                      ></textarea>
                      <div class="img__container mt-2" v-else>
                        <span>لا يوجد عنوان</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>


<script>
import { mapActions, mapGetters } from "vuex";

export default {
  data() {
    return {
      banner_id: this.$route.params.id,
      isloading: true,
      banner: {},
    };
  },
  methods: {
    ...mapActions("bannersModule", ["getBannerById"]),
  },
  async created() {
    this.banner = await this.getBannerById(this.banner_id);
    console.log("banner", this.banner);
  },
  computed: {
    ...mapGetters("bannersModule", ["isLoading"]),
  },
  mounted() {
    this.isloading = this.isLoading;
  },
  watch: {
    isLoading() {
      this.isloading = this.isLoading;
    },
  },
};
</script>

<style lang="scss" >
</style>